import { AlertMessage } from '@/app/components'
import { LoadingAnimation } from '@/components'
import CustomRedemptionModal from '../components/redemptionModal'
import { ViewModelProps } from '../../rewards.viewmodel'
import TremendousModal from '../components/tremendousModal'
import CongratsModal from '../components/congratsModal'
import { useActivityViewModel } from './Activity.viewmodel'
import { PendingTransactionsCard } from './PendingTransactionsCard'
import { CompletedTransactionsCard } from './CompletedTransactionsCard'
import RedeemRewardCard from './RedeemRewardCard'

export default function Activity(parentProps: ViewModelProps) {
  const props = useActivityViewModel(parentProps)

  return (
    <>
      <AlertMessage variant="error" show={!!props.rewardError}>
        {props.rewardError}
      </AlertMessage>
      <div className="flex flex-col justify-center w-full !h-full gap-8">
        <div className="flex flex-col items-center justify-center w-full gap-6">
          <RedeemRewardCard
            transactions={props.transactions}
            pageLoading={props.pageLoading}
            availablePoints={props.availablePoints}
            setPointsRedemptionModalOpen={props.setPointsRedemptionModalOpen}
          />
        </div>
        {props.programNamesWithExternalPayouts.length > 0 && (
          <div className="flex flex-col items-center justify-center w-full gap-4">
            {props.programNamesWithExternalPayouts.map((programName) => (
              <AlertMessage
                className="w-full"
                variant="info"
                key={`external-payout-alert-${programName}`}
              >
                Rewards for {programName} will be paid outside of Optiwatt by
                program partner
              </AlertMessage>
            ))}
          </div>
        )}
        {!!props.transactions.length && !!props.transactions[0].count && (
          <>
            {props.pageLoading && (
              <div className="w-full flex h-full items-center justify-center absolute">
                <LoadingAnimation type="falling" />
              </div>
            )}
            <PendingTransactionsCard {...props} />
            <CompletedTransactionsCard {...props} />
          </>
        )}
      </div>
      <CustomRedemptionModal
        className="md:!max-w-md !w-full !px-4 !py-0 !gap-4 !flex !flex-col !items-center !justify-center"
        id="reward-redemption-modal"
        open={props.pointsRedemptionModalOpen}
        onClose={() => props.setPointsRedemptionModalOpen(false)}
        onRedeem={props.redeem}
        fullscreen={window.screen.width < 768}
        {...props}
      />
      <TremendousModal {...props} />
      <CongratsModal
        {...props}
        open={!!props.pointsRedeemed}
        onClose={props.closeCongratsModal}
      />
    </>
  )
}
